import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=a6f89578&scoped=true&"
import script from "./Licenses.vue?vue&type=script&lang=js&"
export * from "./Licenses.vue?vue&type=script&lang=js&"
import style0 from "./Licenses.css?vue&type=style&index=0&id=a6f89578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f89578",
  null
  
)

export default component.exports